import { ActiveConnectionSVG } from "./ActiveConnectionSVG";
export default ActiveConnectionSVG;
